import React, { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import profile_img from '../assets/images/shoval_profile_image_cropped.jpeg';

gsap.registerPlugin(ScrollTrigger);

const Profile = () => {
  const containerRef = useRef(null);

  useGSAP(() => {
    gsap.from('.profile-text', {
      x: 60,
      autoAlpha: 0,
      duration: 1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: '.profile-text',
        start: 'top 80%',
      },
    });
    gsap.from('.profile-image', {
      x: -60,
      autoAlpha: 0,
      duration: 1,
      ease: 'power3.out',
      scrollTrigger: {
        trigger: '.profile-image',
        start: 'top 80%',
      },
    });
  }, { scope: containerRef });

  return (
    <section ref={containerRef} className="py-20 px-8 bg-white">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12">
        <div className="profile-text flex-1 text-right rtl">
          <h2 className="text-4xl font-bold mb-6 text-gray-800">קצת עלי</h2>
          <p className="text-gray-600 text-lg leading-relaxed">
            נעים להכיר, אני <strong className="bg-pink-100 px-1 rounded">שובל סעדה</strong>, מומחית לייעוץ קריירה עם רקע עשיר בעולם הגיוס
            <br /><br />
            במהלך הקריירה שלי שימשתי כמגייסת למגוון תחומים – טכנולוגיה, רפואה, ניהול, ועוד, תוך שיתוף פעולה עם חברות מובילות בארץ ובעולם
            <br />
            בין החברות איתן עבדתי ניתן למצוא שמות גדולים כמו{' '}
            <strong className="bg-purple-100 px-1 rounded">מיקרוסופט</strong>,{' '}
            <strong className="bg-purple-100 px-1 rounded">סייברריזון</strong>,{' '}
            <strong className="bg-purple-100 px-1 rounded">נייס</strong>, ו-
            <strong className="bg-purple-100 px-1 rounded">טבע</strong>
            <br /><br />
            בשנים האחרונות הרחבתי את הפעילות שלי גם לתחום ייעוץ הקריירה, הלינקדאין שלי מגיע{' '}
            <strong className="bg-purple-200 px-1 rounded">לאלפי אנשים</strong>, ואני מקבלת פניות יומיומיות ממועמדים שמבקשים הכוונה מדויקת
            <br /><br />
            אני כאן כדי לעזור לך לצעוד צעד קדימה בקריירה שלך
          </p>
        </div>
        <div className="profile-image flex-1">
          <img
            src={profile_img}
            alt="Shoval Saada"
            className="w-full h-auto rounded-2xl shadow-2xl"
          />
        </div>
      </div>
    </section>
  );
};

export default Profile;
